var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { styledComponents, theme } from '@datashop/theme';
var styled = styledComponents.default;
var ActionButton = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  background: rgba(0, 0, 0, 0.3);\n  padding: 4px 12px;\n  border-radius: 4px;\n  color: ", ";\n  margin: 16px 8px 4px 0;\n  cursor: pointer;\n"], ["\n  display: inline-block;\n  background: rgba(0, 0, 0, 0.3);\n  padding: 4px 12px;\n  border-radius: 4px;\n  color: ", ";\n  margin: 16px 8px 4px 0;\n  cursor: pointer;\n"])), theme.datashop.palette.white);
var Button = (function (_super) {
    __extends(Button, _super);
    function Button() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Button.prototype.render = function () {
        var _a = this.props, children = _a.children, onClick = _a.onClick;
        return React.createElement(ActionButton, { onClick: onClick }, children);
    };
    return Button;
}(React.PureComponent));
export default Button;
var templateObject_1;
//# sourceMappingURL=button.js.map